<template>
  <div class="approval-detail" v-if="form.activityModel">
    <el-tabs type="card" class="" v-model="activeTab">
      <el-tab-pane label="当前流程" name="current">
        <block title="审批流程" :editable="false" class="block">
          <detail-flow
            :flows="[form.activityModel.activitiNodeDetails]"
            :data-status="form.status"
          ></detail-flow>
        </block>
        <div style="background-color: white">
          <basic-info v-model="form" status="saved"></basic-info>
          <user-info v-model="form" status="saved"></user-info>
        </div>
      </el-tab-pane>
      <el-tab-pane
        label="历史记录"
        name="history"
        v-if="['initiation', 'agent'].includes(this.type)"
      >
        <div class="history-record">
          <template v-if="historyRecord && historyRecord.length">
            <div
              class="record-item"
              v-for="(record, index) of historyRecord"
              :key="index"
              style="border: 1px solid lightgray; margin: 16px; padding: 16px"
            >
              <block title="审批流程" :editable="false" class="block">
                <detail-flow
                  :flows="[record.activityModel.activitiNodeDetails]"
                  :data-status="record.status"
                ></detail-flow>
              </block>
              <div style="background-color: white">
                <basic-info :value="record" status="saved"></basic-info>
                <user-info :value="record" status="saved"></user-info>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="no-record-data">暂无数据</div>
          </template>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div class="operation-wrapper">
      <div class="operation">
        <el-button @click="back" size="medium">返回</el-button>
        <el-button
          @click="
            dialogVisible = true;
            textarea = '';
          "
          type="danger"
          v-if="['agent'].includes(type)"
          size="medium"
          >驳回</el-button
        >
        <el-button
          @click="agree"
          type="primary"
          v-if="['agent'].includes(type)"
          size="medium"
          >通过</el-button
        >
      </div>
    </div>
    <div style="height: 76px"></div>

    <template>
      <!-- 弹出框 -->
      <el-dialog title="驳回" :visible.sync="dialogVisible">
        <!-- <el-radio v-model="rejectType" label="1">驳回本级</el-radio>
        <el-radio v-model="rejectType" label="2">驳回发起人</el-radio> -->
        <el-form>
          <el-form-item label="驳回理由">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入驳回理由"
              v-model="textarea"
              maxlength="80"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="reject">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="通过" :visible.sync="showPassModal">
        <el-form>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入备注"
              v-model="passobj.remark"
              maxlength="80"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showPassModal = false">取 消</el-button>
          <el-button type="primary" @click="pass">确 定</el-button>
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import Block from "@/components/block";
import UserInfo from "@/businessComponents/userInfo";
import BasicInfo from "@/businessComponents/basicInfo.vue";
import DetailFlow from "@/components/detail-flow.vue";
export default {
  name: "ApprovalDetail",
  components: {
    Block,
    UserInfo,
    BasicInfo,
    DetailFlow,
  },
  data() {
    return {
      historyRecord: [],
      activeTab: "current",
      textarea: "",
      dialogVisible: false,
      showPassModal: false,
      rejectType: "1",
      type: "",
      passobj: {},
      form: {
        age: 0,
        bankAccount: "",
        bankName: "",
        birthAddress: {
          cityCode: 0,
          cityName: "",
          code: 0,
          name: "",
          provinceCode: 0,
          provinceName: "",
        },
        birthday: "",
        contractEndTime: "",
        contractsBeginTime: "",
        contractsPartA: "",
        contractsTerm: "",
        deptId: 0,
        education: 0,
        emailAddress: "",
        endTrailTime: "",
        entryTime: "",
        firstContractTime: "",
        homeAddress: "",
        idCard: "",
        isRegular: true,
        joinPartyTime: "",
        joinWorkTime: "",
        learnExperience: [
          {
            academicDegree: 0,
            beginTime: "",
            education: 0,
            endTime: "",
            learnMethod: 0,
            schoolName: "",
            specialty: "",
            witness: "",
          },
        ],
        maritalStatus: 0,
        mobile: "",
        nation: "",
        nativePlace: {
          cityCode: 0,
          cityName: "",
          code: 0,
          name: "",
          provinceCode: 0,
          provinceName: "",
        },
        personnelFilePlace: "",
        politicalStatus: 0,
        positionIds: [],
        ptPositionIds: [],
        rankLevelIds: [],
        residenceAddress: "",
        sex: "",
        staffName: "",
        technicalTitle: "",
        transferRemark: "",
        transferTime: "",
        workAge: 0,
        workExperience: [
          {
            beginTime: "",
            companyName: "",
            deptName: "",
            endTime: "",
            position: "",
            workNature: "",
          },
        ],
        workPlace: {
          cityCode: 0,
          cityName: "",
          code: 0,
          name: "",
          provinceCode: 0,
          provinceName: "",
        },
      },
    };
  },
  props: ["id", "taskId"],
  methods: {
    getHistory() {
      this.$api.personnel
        .inductionApprovalGetHistory({ id: this.id })
        .then(({ data }) => {
          if (data) {
            this.historyRecord = data.list;
          }
        });
    },
    back() {
      this.$emit("changeType");
    },
    reject() {
      this.$api.checkapi
        .rejectMyAppply({
          taskId: this.taskId,
          reason: this.textarea,
          id: this.form.id,
          typeId: 5,
        })
        .then((res) => {
          this.$message.success("申请已驳回");
          this.dialogVisible = false;
          this.$emit("changeType", true);
        });
    },
    // 通过 ，打开通过的模态框
    agree() {
      this.showPassModal = true;
      this.passobj = {};
    },
    pass() {
      // 通过
      this.$api.checkapi
        .passMyAppply({
          taskId: this.taskId,
          id: this.form.id,
          reason: this.passobj.remark ? this.passobj.remark.trim() : "",
          typeId: 5,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.showPassModal = false;
            this.$emit("changeType", true);
          }
        });
    },
    handleData(res) {
      if (res.code == 200) {
        this.form = res.data;
        this.form.activityModel.activitiNodeDetails.forEach((e) => {
          if (e.dealType === "0") {
            // 表示通过，应该为蓝色
            e.color = "#5b69fe";
          } else if (e.dealType === "1") {
            e.color = "#d9001b";
          } else if (e.dealType === "2") {
            e.color = "#d9001b";
          }
        });
        console.log(this.form);
      }
    },
  },
  created() {
    this.type = this.$attrs.type;
    let funcRes;
    if (this.taskId) {
      funcRes = this.$api.personnel.inductionApprovalWaitGet(this.taskId);
    } else {
      funcRes = this.$api.personnel.inductionApprovalProcessGet(this.id);
    }
    funcRes.then((res) => {
      this.handleData(res);
      if (res.data.hasHistory) {
        this.getHistory();
      }
    });
  },
};
</script>

<style lang="scss">
.approval-detail {
  background-color: #fff;
  .approval-sign {
  }
  .operation-wrapper {
    position: fixed;
    bottom: 0;
    background-color: #fff;
    width: calc(100% - 242px);
    left: 241px;
    box-sizing: border-box;
    height: 68px;
    z-index: 10;
    text-align: center;
    .operation {
      padding: 16px;
      margin: 0 20px;
    }
  }
  .block {
    background-color: white;
    padding: 20px;
    margin-bottom: 20px;
  }
}
</style>